import { RotationDirectionType } from '../../../../shared/dynamic-conduct-model/rotation/rotation-direction-type';
var RingGraphConst = /** @class */ (function () {
    function RingGraphConst() {
    }
    RingGraphConst.defaultRotationDirection = RotationDirectionType.ClockWise;
    RingGraphConst.defaultIsFullRing = true;
    RingGraphConst.defaultStartAngle = 270;
    RingGraphConst.defaultEndAngle = 270;
    RingGraphConst.defaultRadiusPercentage = 70;
    RingGraphConst.defaultMinCalibration = 0;
    RingGraphConst.defaultMaxCalibration = 100;
    RingGraphConst.defaultCalibrationPercentageFont = '16px';
    RingGraphConst.defaultCalibrationColor = '#333333';
    RingGraphConst.defaultCalibrationDigitColor = '#333333';
    RingGraphConst.defaultCalibrationDigitFontStyle = '12px';
    RingGraphConst.defaultMasterCalibrations = 10;
    RingGraphConst.defaultSubCalibrations = 5;
    RingGraphConst.defaultPercentageColor = '#333333';
    RingGraphConst.defaultBorderColor = 'rgba(255,255,255,0)';
    RingGraphConst.defaultBackgroundColor = '#eeeeee';
    RingGraphConst.defaultBarColor = '#3695ff';
    RingGraphConst.defaultUpperLimit = 90;
    RingGraphConst.defaultLowerLimit = 10;
    RingGraphConst.defaultUpperLimitColor = '#ff4448';
    RingGraphConst.defaultLowerLimitColor = '#6344ff';
    RingGraphConst.defaultIntegerDigits = 3;
    RingGraphConst.defaultFractionDigits = 0;
    return RingGraphConst;
}());
export { RingGraphConst };
